import moment, {Moment} from 'moment';

import AuthService, {IAPIResponse} from './AuthService';
import TimeTrackingDay from '../Tracking/DataModels/TimeTrackingDay';
import TimeTrackingMonth from '../Tracking/DataModels/TimeTrackingMonth';

interface GetTrackedTimesResponse {
	monthData: Record<string, any>;
}

interface GetMultipleTrackedTimesResponse {
	months: Record<string, any>[];
}

export class LoxoneRESTLog {
	public time: Moment;

	public constructor(values: Record<string, any> = {}) {
		this.time = moment(values.time);
	}
}

class TimeTrackingService extends AuthService {
	public async getAllTrackedTimes(): Promise<TimeTrackingMonth[]> {
		const url = '/api/timeTracking/';

		const data = await this.fetch<GetTrackedTimesResponse>(url, {
			method: 'GET',
		});
		const timeTrackingMonths: TimeTrackingMonth[] = [];
		for (const monthData of data.monthData as TimeTrackingMonth[]) {
			timeTrackingMonths.push(new TimeTrackingMonth(monthData));
		}
		return timeTrackingMonths;
	}

	public async getTrackedTimes(
		selectedMonth: Moment
	): Promise<TimeTrackingMonth> {
		const url = `/api/timeTracking/${selectedMonth.year().toString()}-${selectedMonth.month().toString()}`;

		const data = await this.fetch<GetTrackedTimesResponse>(url, {
			method: 'GET',
		});

		return new TimeTrackingMonth(data.monthData);
	}

	public async getMultipleTrackedTimes(
		selectedMonth: Moment
	): Promise<TimeTrackingMonth[]> {
		const url = `/api/timeTracking/multiple/${selectedMonth.year().toString()}-${selectedMonth.month().toString()}`;

		const data = await this.fetch<GetMultipleTrackedTimesResponse>(url, {
			method: 'GET',
		});
		const months: TimeTrackingMonth[] = [];
		for (const month of data.months) {
			const timeTrackingMonth = new TimeTrackingMonth(month.month);
			timeTrackingMonth.userName = month.userName;
			timeTrackingMonth.userEmail = month.userEmail;
			months.push(timeTrackingMonth);
		}

		return months;
	}

	public saveTrackedTimes(data: TimeTrackingMonth): Promise<void> {
		return this.fetch(
			`/api/timeTracking/${data.year.toString()}-${data.month.toString()}`,
			{
				method: 'POST',
				body: JSON.stringify(data),
			}
		);
	}

	// TODO: do we really need to return the response or would it be sufficient to only return the logs array?
	public async getLoxoneData(
		timeTrackingData: TimeTrackingDay
	): Promise<LoxoneRESTLog[]> {
		try {
			const data = await this.fetch<IAPIResponse<LoxoneRESTLog[]>>(
				`/api/timeTracking/loxoneData/${timeTrackingData.date.format('YYYY-MM-DD')}`,
				{
					method: 'GET',
				}
			);

			if (data.success && data.data) {
				const logs = [];

				for (const jsonLog of data.data) {
					logs.push(new LoxoneRESTLog(jsonLog));
				}

				return logs.reverse();
			}
		} catch (error) {
			console.log('Error while reading loxone logs', error);
		}

		return [];
	}
}

export default TimeTrackingService;
